export default __webpack_public_path__ + "static/media/qana-project-2.2c3bbf81.jpg";